import { FormValues } from "../interfaces/InstitucionalSite";
import BaseApi from "./BaseApi";

const baseUrl = 'api/InstitutionalSite/';

type response = {
    success: boolean,
    errors: Array<string>
}

class InstitutionalSiteService {
    static Save(data: FormValues): Promise<response> {
        return BaseApi.post(`${baseUrl}data`, data);
    }
}

export default InstitutionalSiteService;